<template>
    <veui-dialog
        title="立即咨询"
        :open="open"
        overlay-class="contact-overlay"
        @cancel="handleClose"
        @ok="handleClose"
    >
        <div>{{ contactInfo.text }}</div>
        <div
            v-for="{label, value} in contactInfo.contactList"
            :key="value"
            class="contact-tips"
        >
            <span>{{ label }}：{{ value }}</span>
            <veui-button
                ui="icon"
                @click="handleCopy(value)"
            >
                <veui-icon name="copy" class="copt-icon"/>
            </veui-button>
        </div>
    </veui-dialog>
</template>

<script>
import {Dialog, Button, Icon} from 'veui';
import {copyText} from '@/lib/helper';
import {contactInfo} from '@/common/couponConfig';
import 'veui-theme-dls-icons/copy';
export default {
    name: 'ContactDialog',
    inject: ['$toast'],
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-icon': Icon
    },
    props: {
        open: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        };
    },
    computed: {
        isOuterUser() {
            return this.$store.state.app.userInfo.isOuterUser;
        },
        contactInfo() {
            const ucType = this.isOuterUser ? 'outerUC' : 'innerUC';
            return contactInfo[ucType];
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:open', false);
        },
        async handleCopy(value) {
            const result = copyText(value);
            if (result) {
                this.$toast.success('复制成功');
            }
            else {
                this.$toast.error('复制失败');
            }
        }
    }
};
</script>

<style scoped lang="less">
.contact-overlay {
    /deep/ .veui-dialog-content {
        width: 500px;
        border-radius: 16px;
        background-color: var(--Brand-1, #F2F7FF);
        background-image: url(https://qiaojiang.cdn.bcebos.com/fe/voice-contact-bg.png);
        background-size: 100%;
        box-shadow:
            0px 8px 16px 4px rgba(0, 71, 194, 0.08),
            0px 7px 14px 2px rgba(0, 71, 194, 0.07),
            0px 1px 8px 0px rgba(0, 71, 194, 0.05);
        &-foot {
            display: none;
        }
        &-body {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-top: 12px;
            font-size: 16px;
            .contact-tips {
                font-size: 16px;
                font-weight: 500;
                padding: 12px 16px;
                background: #fff;
                border-radius: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
        }
    }
}
</style>